import dayjs from 'dayjs';
import {
  AratData,
  Assessment,
  AssessmentChartDataSetCustom,
  AssessmentChartDataSets,
  AssessmentSubType,
  AssessmentType,
  BbsData,
  BbsDataSet,
  BbtData,
  CustomAssessment,
  CustomData,
  CustomDataSet,
  FgaData,
  FgaDataSet,
  FrData,
  Mwt6Data,
  NhptData,
  NhptDataSet,
  SingleNumberDataSet,
  SubTestChartDataSet,
  SubTestDataSet,
  TsData,
  TsDataSet,
  TugData,
  TwoHandsNumberDataSet,
} from './model';

export function getMinMaxDate(datasetsObject: AssessmentChartDataSets): {
  minDate: string;
  maxDate: string;
  labelDataFull: Array<Date>;
} {
  const keys: Array<AssessmentType> = Object.keys(datasetsObject) as Array<AssessmentType>;
  const labelDataFull: Array<Date> = keys.flatMap((type: AssessmentType) => {
    return datasetsObject[type]!.map(row => new Date(new Date(row.dateIso).toDateString()));
  });
  // labelDataFull.push(
  //   dayjs(labelDataFull[labelDataFull.length - 1])
  //     .add(30, 'day')
  //     .toDate()
  // );
  // labelDataFull.push(dayjs(labelDataFull[0]).subtract(3, 'day').toDate());

  labelDataFull.sort((a, b) => a.getTime() - b.getTime());
  let maxDateDayJs = dayjs(labelDataFull[labelDataFull.length - 1]).add(3, 'day');
  let minDateDayJs = dayjs(labelDataFull[0]).subtract(3, 'day');
  // Manuell etwas mehr Zeitraum hinzufügen, damit die Balken nicht so dick sind, falls nur 1 Datum existiert bisher.
  const diff = Math.abs(minDateDayJs.diff(maxDateDayJs, 'day'));
  // console.log('diff', diff);
  if (diff < 6 * 7) {
    const subst = 6 * 7 - diff;
    maxDateDayJs = dayjs(maxDateDayJs).add(subst, 'day');
    // minDateDayJs = dayjs(labelDataFull[0]).subtract(subst, 'day');
  }
  const minDate = minDateDayJs.toISOString();
  const maxDate = maxDateDayJs.toISOString();

  return { minDate, maxDate, labelDataFull };
}

export function generateChartReportCustom(assessments: Assessment[], customAssessmentList: CustomAssessment[]) {
  const datasets: AssessmentChartDataSetCustom[] = [];
  assessments.forEach(assessment => {
    if (assessment.type === 'CUSTOM') {
      const customAssessment: CustomAssessment = customAssessmentList.filter(
        (item: CustomAssessment) => item.id === assessment.customId!
      )[0];
      const foundDatasets: AssessmentChartDataSetCustom[] = datasets.filter(
        (item: AssessmentChartDataSetCustom) => item.customAssessment.id === assessment.customId!
      );
      const dataset: AssessmentChartDataSetCustom =
        foundDatasets.length === 1
          ? foundDatasets[0]
          : { customAssessment, assessmentList: [], assessmentChartDataRows: [] };
      dataset.assessmentList.push({ ...assessment });
      dataset.assessmentChartDataRows.push({
        score: getScore(assessment, 'both'),
        score_left: getScore(assessment, 'left'),
        score_right: getScore(assessment, 'right'),
        subDataSets: getSubDataSets(assessment),
        dateIso: assessment.dateIso,
        documentId: assessment._documentId,
        type: assessment.type,
        hasComment: assessment.note ? assessment.note.length > 0 : false,
        comment: assessment.note,
      });
      if (foundDatasets.length === 0) {
        datasets.push(dataset);
      }
    }
  });
  console.log('[chart.function.data] generateChartReportCustom history', datasets);
  return datasets;
}

export function generateChartReport(assessments: Assessment[]) {
  const assessmentChartDataSets: AssessmentChartDataSets = {
    // ARAT?: AssessmentChartDataSet | undefined;
    // BBT?: AssessmentChartDataSet | undefined;
    // ASECS?: AssessmentChartDataSet | undefined;
    // NHPT?: AssessmentChartDataSet | undefined;
    // BBS?: AssessmentChartDataSet | undefined;
  };
  assessments.forEach(assessment => {
    const type = assessment.type;
    if (assessmentChartDataSets[type] === undefined) {
      assessmentChartDataSets[type] = [];
    }
    if (type === 'ARAT') {
      assessmentChartDataSets[type]?.push({
        score: getPercent(assessment.scorePercentage),
        score_left: getPercent(assessment.scorePercentageLeft),
        score_right: getPercent(assessment.scorePercentageRight),
        subDataSets: getSubDataSets(assessment),
        dateIso: assessment.dateIso,
        documentId: assessment._documentId,
        type: assessment.type,
        hasComment: assessment.note ? assessment.note.length > 0 : false,
        comment: assessment.note,
      });
    } else {
      assessmentChartDataSets[type]?.push({
        score: getScore(assessment, 'both'),
        score_left: getScore(assessment, 'left'),
        score_right: getScore(assessment, 'right'),
        subDataSets: getSubDataSets(assessment),
        dateIso: assessment.dateIso,
        documentId: assessment._documentId,
        type: assessment.type,
        hasComment: assessment.note ? assessment.note.length > 0 : false,
        comment: assessment.note,
      });
    }
  });
  console.log('[chart.function.data] assessmentChartDataSets', assessmentChartDataSets);
  return assessmentChartDataSets;
}

const getSubDataSets = (assessment: Assessment) => {
  const subDataSets: Array<SubTestChartDataSet> = [];
  if (assessment.type === 'ARAT') {
    const data: AratData = assessment.data as AratData;
    // const keys = Object.keys(data) as Array<keyof AratData>;
    const keys = ['grasp', 'grip', 'pinch', 'gross'] as Array<keyof AratData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
      const subDataSet = getSubTestChartDataSetTwoHandsNew(subTest, subType);
      if (subDataSet.comment) {
        if (subType === 'grasp') {
          subDataSet.comment = '1. Greifen: ' + subDataSet.comment + '\n';
        }
        if (subType === 'grip') {
          subDataSet.comment = '2. Griff: ' + subDataSet.comment + '\n';
        }
        if (subType === 'pinch') {
          subDataSet.comment = '3. Präzisionsgriff: ' + subDataSet.comment + '\n';
        }
        if (subType === 'gross') {
          subDataSet.comment = '4. Basale Armbewegung: ' + subDataSet.comment + '\n';
        }
      }
      subDataSets.push(subDataSet);
    });
  } else if (assessment.type === 'NHPT') {
    const data: NhptData = assessment.data as NhptData;
    const keys = Object.keys(data) as Array<keyof NhptData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<NhptDataSet> = data[subType];
      subDataSets.push(getSubTestChartDataSetNhpt(subTest, subType));
    });
  } else if (assessment.type === 'BBS') {
    const data: BbsData = assessment.data as BbsData;
    const keys = Object.keys(data) as Array<keyof BbsData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<BbsDataSet> = data[subType];
      const score = getPercent(getScore(assessment, 'both'));
      const sum = subTest.data.reduce((sum, currentValue) => sum + (currentValue.value ?? 0), 0);
      const hasComment = subTest.note?.length > 0;
      const comment = subTest.note;
      subDataSets.push({ subType, score, sum, hasComment, comment });
    });
  } else if (assessment.type === 'FGA') {
    const data: FgaData = assessment.data as FgaData;
    const keys = Object.keys(data) as Array<keyof FgaData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<FgaDataSet> = data[subType];
      const score = getPercent(getScore(assessment, 'both'));
      const sum = subTest.data.reduce((sum, currentValue) => sum + (currentValue.value ?? 0), 0);
      const hasComment = subTest.note?.length > 0;
      const comment = subTest.note;
      subDataSets.push({ subType, score, sum, hasComment, comment });
    });
    // } else if (assessment.type === 'MWT6') {
    //   const data: Mwt6Data = assessment.data as Mwt6Data;
    //   const keys = Object.keys(data) as Array<keyof Mwt6Data>;
    //   keys.forEach(subType => {
    //     const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
    //     const score = getPercent(subTest.score);
    //     const sum = subTest.data.reduce((sum, currentValue) => sum + (currentValue.value ?? 0), 0);
    //     subDataSets.push({ subType, score, sum });
    //   });
  } else if (assessment.type === 'TUG') {
    const data: TugData = assessment.data as TugData;
    const keys = Object.keys(data) as Array<keyof TugData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
      subDataSets.push(getSubTestChartDataSetSingleNumber(subTest, subType));
    });
  } else if (assessment.type === 'BBT') {
    const data: BbtData = assessment.data as BbtData;
    const keys = Object.keys(data) as Array<keyof BbtData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
      subDataSets.push(getSubTestChartDataSetTwoHands(subTest, subType));
    });
    // } else if (assessment.type === 'TS') {
    //   const data: TsData = assessment.data as TsData;
    //   const keys = Object.keys(data) as Array<keyof TsData>;
    //   keys.forEach(subType => {
    //     // @TODO: subDataSets.push(getSubTestChartDataSetTwoHands(subTest, subType));
    //     const subTest: SubTestDataSet<TsDataSet> = data[subType];
    //     const score = getPercent(subTest.score);
    //     const sumLeft = subTest.data.reduce((sum, currentValue) => sum + (currentValue.left.value ?? 0), 0);
    //     const sumRight = subTest.data.reduce((sum, currentValue) => sum + (currentValue.right.value ?? 0), 0);
    //     const score_left = getPercent(subTest.score_left);
    //     const score_right = getPercent(subTest.score_right);
    //     subDataSets.push({ subType, score, sumRight, sumLeft, score_left, score_right });
    //   });
    // } else if (assessment.type === 'FR') {
    //   const data: FrData = assessment.data as FrData;
    //   const keys = Object.keys(data) as Array<keyof FrData>;
    //   keys.forEach(subType => {
    //     const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
    //     const score = getPercent(subTest.score);
    //     const sum = subTest.data.reduce((sum, currentValue) => sum + (currentValue.value ?? 0), 0);
    //     subDataSets.push({ subType, score, sum });
    //   });
  }
  return subDataSets;
};

const getScore = (assessment: Assessment, side: 'left' | 'right' | 'both') => {
  let score = 0;
  if (assessment.type === 'ARAT') {
    // const data: AratData = assessment.data as AratData;
    // score = data.
    // const keys = Object.keys(data) as Array<keyof AratData>;
    // keys.forEach(subType => {
    //   const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
    //   score = getPercentTwoHands(subTest, score, side);
    // });
  } else if (assessment.type === 'CUSTOM') {
    const data: CustomData = assessment.data as CustomData;
    const keys = Object.keys(data) as Array<keyof CustomData>;
    keys.forEach(subType => {
      const subTest: CustomDataSet<TwoHandsNumberDataSet> = data[subType];
      score = getPercentCustom(subTest, score, side);
    });
  } else if (assessment.type === 'BBT') {
    const data: BbtData = assessment.data as BbtData;
    const keys = Object.keys(data) as Array<keyof BbtData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
      score = getPercentTwoHands(subTest, score, side);
    });
  } else if (assessment.type === 'NHPT') {
    const data: NhptData = assessment.data as NhptData;
    const keys = Object.keys(data) as Array<keyof NhptData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
      score = getPercentTwoHands(subTest, score, side);
    });
  } else if (assessment.type === 'BBS') {
    const data: BbsData = assessment.data as BbsData;
    const keys = Object.keys(data) as Array<keyof BbsData>;
    // ist nur singular: bbs
    keys.forEach(subType => {
      const subTest: SubTestDataSet<BbsDataSet> = data[subType];
      subTest.data.forEach(subSubTest => (score += subSubTest.score ?? 0));
      const averageScore = score / subTest.data.length;
      score = getPercent(averageScore);
    });
  } else if (assessment.type === 'FGA') {
    const data: FgaData = assessment.data as FgaData;
    // const keys = Object.keys(data) as Array<keyof FgaData>;
    // ist nur singular: fga
    // keys.forEach(subType => {
    //   const subTest: SubTestDataSet<FgaDataSet> = data[subType];
    //   subTest.data.forEach(subSubTest => (score += subSubTest.score ?? 0));
    //   const averageScore = score / subTest.data.length;
    //   score = getPercent(averageScore);
    // });
    score = getPercent(data.fga.score ?? -1);
  } else if (assessment.type === 'TS') {
    const data: TsData = assessment.data as TsData;
    const keys = Object.keys(data) as Array<keyof TsData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<TsDataSet> = data[subType];
      const subTestScore = getPercent(subTest.score);
      score = subTestScore > score ? subTestScore : score;
    });
  } else if (assessment.type === 'FR') {
    const data: FrData = assessment.data as FrData;
    const keys = Object.keys(data) as Array<keyof FrData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
      const subTestScore = getPercent(subTest.score);
      score = subTestScore > score ? subTestScore : score;
    });
  } else if (assessment.type === 'MWT6') {
    const data: Mwt6Data = assessment.data as Mwt6Data;
    const keys = Object.keys(data) as Array<keyof Mwt6Data>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
      const subTestScore = getPercent(subTest.score);
      score = subTestScore > score ? subTestScore : score;
    });
  } else if (assessment.type === 'TUG') {
    const data: TugData = assessment.data as TugData;
    const keys = Object.keys(data) as Array<keyof TugData>;
    keys.forEach(subType => {
      const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
      const subTestScore = getPercent(subTest.score);
      score = subTestScore > score ? subTestScore : score;
    });
  }
  return score;
};

function getPercent(score: number | null | undefined): number {
  if (score !== undefined && score !== null) {
    return Math.round(score * 100);
  } else {
    return 0;
  }
}

function getPercentForCustom(score: number | null | undefined): number {
  if (score !== undefined && score !== null) {
    return 100 - score; // umrechnung von Erfüllung auf Schädigung!
  } else {
    return 0;
  }
}
function getPercentNhpt(score: number | null | undefined): number {
  if (score !== undefined && score !== null) {
    return Math.round((score / 18) * 100);
  } else {
    return 0;
  }
}

function getPercentCustom(
  subTest: CustomDataSet<TwoHandsNumberDataSet>,
  score: number,
  side: 'left' | 'right' | 'both'
): number {
  const hasLeftValues: boolean = subTest.data.every(row => row.valueLeft !== null);
  const hasRightValues: boolean = subTest.data.every(row => row.valueRight !== null);
  const leftScore = hasLeftValues ? getPercentForCustom(subTest.data[0].valueLeft) : 0;
  const rightScore = hasRightValues ? getPercentForCustom(subTest.data[0].valueRight) : 0;
  switch (side) {
    case 'left':
      return leftScore;
    case 'right':
      return rightScore;
    case 'both': {
      const subTestScore = leftScore > rightScore ? leftScore : rightScore;
      return subTestScore > score ? subTestScore : score;
    }
  }
}

function getPercentTwoHands(
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  score: number,
  side: 'left' | 'right' | 'both'
): number {
  const hasLeftValues: boolean = subTest.data.every(row => row.valueLeft !== null);
  const hasRightValues: boolean = subTest.data.every(row => row.valueRight !== null);
  const leftScore = hasLeftValues ? getPercent(subTest.score_left) : 0;
  const rightScore = hasRightValues ? getPercent(subTest.score_right) : 0;
  switch (side) {
    case 'left':
      return leftScore;
    case 'right':
      return rightScore;
    case 'both': {
      const subTestScore = leftScore > rightScore ? leftScore : rightScore;
      return subTestScore > score ? subTestScore : score;
    }
  }
}

function getSubTestChartDataSetSingleNumber(
  subTest: SubTestDataSet<SingleNumberDataSet>,
  subType: AssessmentSubType
): SubTestChartDataSet {
  const hasComment: boolean = subTest.note?.length > 0;
  const comment = subTest.note;
  const hasValues: boolean = subTest.data.every(row => row.value !== null);

  const sum = subTest.data.reduce((sum, currentValue) => sum + (currentValue.value ?? 0), 0);
  const score = hasValues ? getPercent(subTest.score_left) : 0;
  const subTestScore = score;
  return {
    subType,
    score: subTestScore,
    sum,
    norm: subTest.norm,
    hasComment,
    comment,
  };
}

function getSubTestChartDataSetTwoHands(
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  subType: AssessmentSubType
): SubTestChartDataSet {
  const hasComment: boolean = subTest.note?.length > 0;
  const comment = subTest.note;
  const hasLeftValues: boolean = subTest.data.every(row => row.valueLeft !== null);
  const hasRightValues: boolean = subTest.data.every(row => row.valueRight !== null);

  const sumLeft = subTest.data.reduce((sum, currentValue) => sum + (currentValue.valueLeft ?? 0), 0);
  const sumRight = subTest.data.reduce((sum, currentValue) => sum + (currentValue.valueRight ?? 0), 0);
  const score_left = hasLeftValues ? getPercent(subTest.score_left) : 0;
  const score_right = hasRightValues ? getPercent(subTest.score_right) : 0;
  const subTestScore = score_left > score_right ? score_left : score_right;
  return {
    subType,
    score: subTestScore,
    sumRight,
    sumLeft,
    score_left,
    score_right,
    norm_left: subTest.norm_left,
    norm_right: subTest.norm_right,
    hasComment,
    comment,
  };
}

function getSubTestChartDataSetTwoHandsNew(
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  subType: AssessmentSubType
): SubTestChartDataSet {
  const hasComment: boolean = subTest.note?.length > 0;
  const comment = subTest.note;
  const hasLeftValues: boolean = subTest.data.every(row => row.valueLeft !== null);
  const hasRightValues: boolean = subTest.data.every(row => row.valueRight !== null);

  const sumLeft = subTest.data.reduce((sum, currentValue) => sum + (currentValue.valueLeft ?? 0), 0);
  const sumRight = subTest.data.reduce((sum, currentValue) => sum + (currentValue.valueRight ?? 0), 0);
  const score_left = hasLeftValues ? getPercent(subTest.scoreLeftPercentage) : 0;
  const score_right = hasRightValues ? getPercent(subTest.scoreRightPercentage) : 0;
  const subTestScore = hasRightValues ? getPercent(subTest.scorePercentage) : 0;
  return { subType, score: subTestScore, sumRight, sumLeft, score_left, score_right, hasComment, comment };
}

function getSubTestChartDataSetNhpt(
  subTest: SubTestDataSet<NhptDataSet>,
  subType: AssessmentSubType
): SubTestChartDataSet {
  const hasComment: boolean = subTest.note?.length > 0;
  const comment = subTest.note;
  const hasLeftValues: boolean = subTest.data.every(row => row.valueLeft !== null);
  const hasRightValues: boolean = subTest.data.every(row => row.valueRight !== null);

  const sumLeft = subTest.data.reduce((sum, currentValue) => sum + (currentValue.valueLeft ?? 0), 0);
  const sumRight = subTest.data.reduce((sum, currentValue) => sum + (currentValue.valueRight ?? 0), 0);
  const score_left = hasLeftValues ? getPercent(subTest.score_left) : 0;
  const score_right = hasRightValues ? getPercent(subTest.score_right) : 0;
  const subTestScore = score_left > score_right ? score_left : score_right;

  // Achtung: Erfüllung hier ist 100% maximaler Erfolg, muss also invertiert werden damit es
  // zu den anderen scores passt, die ja Schädigung abbilden, nicht Erfüllung
  const extraLeft = 100 - getPercentNhpt(subTest.data[0].overtimeCountLeft);
  const extraRight = 100 - getPercentNhpt(subTest.data[0].overtimeCountRight);
  return {
    subType,
    score: subTestScore,
    sumRight,
    sumLeft,
    norm_left: subTest.norm_left,
    norm_right: subTest.norm_right,
    score_left,
    score_right,
    extraLeft,
    extraRight,
    hasComment,
    comment,
  };
}
